import { HttpErrorResponse } from '@angular/common/http';

/**
 * Generic class for all config service failures
 */
export class ConfigServiceFailure implements Error {
  err: Error;
  name: string;
  stack?: string | undefined;

  constructor(err: Error) {
    this.err = err;
    this.name = err.name;
    this.stack = err.stack;
  }

  get message() {
    return this.err.message;
  }

  get error(): Error {
    return this.err;
  }
}

export class HttpFailure extends ConfigServiceFailure {
  code: number;

  constructor(err: HttpErrorResponse, args: object) {
    super(err);
    Object.assign(this, args);
  }
}

export class UnknownConfigFailure extends ConfigServiceFailure {
  constructor(err: Error) {
    super(err);
  }
}

/**
 * A class that provides methods for creating failure objects related to the
 * configuration service.
 */
export class ConfigServiceFailures {
  /**
   * Creates an HttpFailure object with the given code.
   * @param code The HTTP status code of the failure.
   * @returns An HttpFailure object.
   */
  static httpFailure(err: HttpErrorResponse, code: number) {
    return new HttpFailure(err, {
      code,
    });
  }

  /**
   * Creates an UnknownConfigFailure object.
   * @returns An UnknownConfigFailure object.
   */
  static unknown(err: Error) {
    return new UnknownConfigFailure(err);
  }
}
